import * as RadixAccordion from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';
import { Icon } from '@/components/atoms/Icon';
import { cn } from '@/utils/cn';
import styles from './Accordion.module.scss';
import type { AccordionProps } from './Accordion.types';

/**
 * Acordeón accesible (Radix) estilado con el design system. Usado, p. ej., para
 * las FAQs de la pantalla de Soporte. Teclado + ARIA los aporta Radix.
 */
export function Accordion({ items, type = 'single', className }: AccordionProps) {
  const renderItems = items.map((item) => (
    <RadixAccordion.Item key={item.id} value={item.id} className={styles.accordion__item}>
      <RadixAccordion.Header className={styles.accordion__header}>
        <RadixAccordion.Trigger className={styles.accordion__trigger} data-no-press-scale="">
          <span className={styles.accordion__title}>{item.title}</span>
          <Icon icon={ChevronDown} size="md" className={styles.accordion__chevron} />
        </RadixAccordion.Trigger>
      </RadixAccordion.Header>
      <RadixAccordion.Content className={styles.accordion__content}>
        <div className={styles.accordion__contentInner}>{item.content}</div>
      </RadixAccordion.Content>
    </RadixAccordion.Item>
  ));

  const rootClassName = cn(styles.accordion, className);

  return type === 'multiple' ? (
    <RadixAccordion.Root type="multiple" className={rootClassName}>
      {renderItems}
    </RadixAccordion.Root>
  ) : (
    <RadixAccordion.Root type="single" collapsible className={rootClassName}>
      {renderItems}
    </RadixAccordion.Root>
  );
}

Accordion.displayName = 'Accordion';
